import { ReactNode } from 'react';

import { Heading } from '../../chakra';

export interface PageTitleProps {
  children: ReactNode;
}

export function PageTitle({ children }: PageTitleProps) {
  return (
    <Heading as="h1" paddingTop={6} paddingBottom={2}>
      {children}
    </Heading>
  );
}
